import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ActivationPlan from './ActivationPlan';  
import ProtectedRoute from './ProtectedRoute';
import MasterLogin from './Login/MasterLogin';
import ManageAccess from './Compoonents/ManageAccess';
import Header from './Compoonents/Header'; // Import your Header component
import PurchesPlan from './PurchesPlan';

// Create a layout component for protected routes
const ProtectedLayout = ({ children }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <div style={{ flex: 1, padding: '20px' }}>
        {children}
      </div>
    </div>
  ); 
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<MasterLogin />} />
        
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <ActivationPlan/>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-access"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <ManageAccess/>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
          <Route
          path="/purchesplan"
          element={
            <ProtectedRoute>
              <ProtectedLayout>
                <PurchesPlan/>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;